// extracted by mini-css-extract-plugin
export default {"content":"ContentWrapper_content__GyEYf","content_80":"ContentWrapper_content_80__3t-XF"};